import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import CloseIcon from '../../../icons/close.svg';

import styles from './NavBar.styl';

const cx = classNames.bind(styles);

const NavBar = ({ className, children, isTablet, onClose }) => (
  <div className={cx('NavBar', className)}>
    {children}
    <div className={cx('NavBar__close', { NavBar__close_tablet: isTablet })} onClick={onClose}>
      <CloseIcon width={16} height={16} />
    </div>
  </div>
);

NavBar.defaultProps = {
  className: '',
  children: '',
  isTablet: false,
};

NavBar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  onClose: PropTypes.func.isRequired,
  isTablet: PropTypes.bool,
};

export default NavBar;
